"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StxFlowCode = void 0;
/**
 * Enum for either outgoing or incoming requests
 */
var StxFlowCode;
(function (StxFlowCode) {
    StxFlowCode["OUTGOING"] = "OUTGOING";
    StxFlowCode["INCOMING"] = "INCOMING";
})(StxFlowCode = exports.StxFlowCode || (exports.StxFlowCode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R4LWZsb3ctY29kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHgvc3R4LWZsb3ctY29kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7R0FFRztBQUNILElBQVksV0FHWDtBQUhELFdBQVksV0FBVztJQUNyQixvQ0FBcUIsQ0FBQTtJQUNyQixvQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsV0FBVyxHQUFYLG1CQUFXLEtBQVgsbUJBQVcsUUFHdEIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEVudW0gZm9yIGVpdGhlciBvdXRnb2luZyBvciBpbmNvbWluZyByZXF1ZXN0c1xuICovXG5leHBvcnQgZW51bSBTdHhGbG93Q29kZSB7XG4gIE9VVEdPSU5HID0gJ09VVEdPSU5HJyxcbiAgSU5DT01JTkcgPSAnSU5DT01JTkcnXG59XG4iXX0=